import React from 'react';

const ProfileSVGOld = ({ className, parentClassName }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 25.9C21.4676 25.9 25.9 21.4675 25.9 16C25.9 10.5324 21.4676 6.1 16 6.1C10.5325 6.1 6.1 10.5324 6.1 16C6.1 21.4675 10.5325 25.9 16 25.9ZM16 27C22.0753 27 27 22.0753 27 16C27 9.92469 22.0753 5 16 5C9.9247 5 5 9.92469 5 16C5 22.0753 9.9247 27 16 27Z"
      fill="none"
      className={className}
    />
    <path
      d="M9.3999 22.3965C9.3999 21.8284 9.8245 21.3482 10.3899 21.2855C14.6332 20.8158 17.3859 20.8582 21.6198 21.296C21.8312 21.3182 22.0316 21.4015 22.1965 21.5357C22.3613 21.6699 22.4836 21.8492 22.5482 22.0517C22.6128 22.2542 22.6171 22.4712 22.5604 22.6761C22.5038 22.881 22.3887 23.065 22.2292 23.2056C17.2325 27.561 14.3769 27.501 9.7519 23.21C9.5264 23.001 9.3999 22.704 9.3999 22.3971V22.3965Z"
      fill="none"
      className={className}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5634 21.8426C17.363 21.4081 14.6499 21.3674 10.4501 21.8322C10.3118 21.8483 10.1844 21.9148 10.0921 22.0191C9.99986 22.1233 9.9493 22.2579 9.9501 22.397C9.9501 22.5543 10.0156 22.7034 10.1261 22.8068C12.4185 24.9331 14.1554 25.8939 15.8533 25.9C17.5571 25.906 19.3875 24.9529 21.868 22.7914C21.9469 22.7212 22.0036 22.6297 22.0313 22.5279C22.0591 22.4262 22.0567 22.3185 22.0244 22.2181C21.9922 22.1176 21.9314 22.0287 21.8495 21.9622C21.7677 21.8956 21.6683 21.8543 21.5634 21.8432V21.8426ZM10.3296 20.7388C14.6174 20.2641 17.4103 20.307 21.6772 20.7487C21.9953 20.7819 22.2968 20.9071 22.5447 21.109C22.7927 21.3109 22.9765 21.5807 23.0735 21.8855C23.1705 22.1902 23.1765 22.5166 23.0909 22.8247C23.0053 23.1328 22.8316 23.4093 22.5913 23.6202C20.0751 25.8136 17.9795 27.0082 15.8499 27C13.7143 26.9923 11.7112 25.7773 9.37865 23.6131C9.21164 23.4575 9.07851 23.2692 8.98757 23.0599C8.89663 22.8505 8.84983 22.6247 8.8501 22.3965C8.8493 21.9864 8.99981 21.5905 9.27281 21.2845C9.54581 20.9785 9.9221 20.784 10.3296 20.7382V20.7388Z"
      fill="none"
      className={className}
    />
    <path
      d="M20.4001 13.8C20.4001 14.967 19.9365 16.0861 19.1114 16.9113C18.2862 17.7364 17.1671 18.2 16.0001 18.2C14.8331 18.2 13.714 17.7364 12.8888 16.9113C12.0637 16.0861 11.6001 14.967 11.6001 13.8C11.6001 12.6331 12.0637 11.5139 12.8888 10.6888C13.714 9.86359 14.8331 9.40002 16.0001 9.40002C17.1671 9.40002 18.2862 9.86359 19.1114 10.6888C19.9365 11.5139 20.4001 12.6331 20.4001 13.8Z"
      fill="none"
      className={className}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0001 17.1C16.8753 17.1 17.7147 16.7523 18.3336 16.1335C18.9524 15.5146 19.3001 14.6752 19.3001 13.8C19.3001 12.9248 18.9524 12.0854 18.3336 11.4666C17.7147 10.8477 16.8753 10.5 16.0001 10.5C15.1249 10.5 14.2855 10.8477 13.6666 11.4666C13.0478 12.0854 12.7001 12.9248 12.7001 13.8C12.7001 14.6752 13.0478 15.5146 13.6666 16.1335C14.2855 16.7523 15.1249 17.1 16.0001 17.1ZM16.0001 18.2C17.1671 18.2 18.2862 17.7364 19.1114 16.9113C19.9365 16.0861 20.4001 14.967 20.4001 13.8C20.4001 12.6331 19.9365 11.5139 19.1114 10.6888C18.2862 9.86359 17.1671 9.40002 16.0001 9.40002C14.8331 9.40002 13.714 9.86359 12.8888 10.6888C12.0637 11.5139 11.6001 12.6331 11.6001 13.8C11.6001 14.967 12.0637 16.0861 12.8888 16.9113C13.714 17.7364 14.8331 18.2 16.0001 18.2Z"
      fill="none"
      className={className}
    />
  </svg>
);

const ProfileSVG = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21C16.9705 21 21 16.9705 21 12C21 7.0295 16.9705 3 12 3C7.0295 3 3 7.0295 3 12C3 16.9705 7.0295 21 12 21ZM12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
      fill="none"
      className={className}
    />
    <path
      d="M6 17.815C6 17.2985 6.386 16.862 6.9 16.805C10.7575 16.378 13.26 16.4165 17.109 16.8145C17.3012 16.8347 17.4834 16.9104 17.6333 17.0324C17.7831 17.1544 17.8942 17.3175 17.953 17.5016C18.0117 17.6857 18.0156 17.8829 17.9641 18.0692C17.9126 18.2555 17.808 18.4227 17.663 18.5505C13.1205 22.51 10.5245 22.4555 6.32 18.5545C6.115 18.3645 6 18.0945 6 17.8155V17.815Z"
      fill="none"
      className={className}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0575 17.3115C13.239 16.9165 10.7725 16.8795 6.9545 17.302C6.82882 17.3167 6.71296 17.3771 6.6291 17.4719C6.54524 17.5666 6.49928 17.689 6.5 17.8155C6.5 17.9585 6.5595 18.094 6.66 18.188C8.744 20.121 10.323 20.9945 11.8665 21C13.4155 21.0055 15.0795 20.139 17.3345 18.174C17.4061 18.1102 17.4577 18.027 17.483 17.9345C17.5082 17.842 17.506 17.7441 17.4767 17.6528C17.4473 17.5615 17.3921 17.4807 17.3177 17.4202C17.2433 17.3597 17.1529 17.3221 17.0575 17.312V17.3115ZM6.845 16.308C10.743 15.8765 13.282 15.9155 17.161 16.317C17.4502 16.3472 17.7242 16.461 17.9497 16.6446C18.1751 16.8281 18.3422 17.0734 18.4304 17.3505C18.5185 17.6275 18.524 17.9242 18.4462 18.2043C18.3683 18.4844 18.2105 18.7357 17.992 18.9275C15.7045 20.9215 13.7995 22.0075 11.8635 22C9.922 21.993 8.101 20.8885 5.9805 18.921C5.82868 18.7796 5.70765 18.6084 5.62497 18.4181C5.5423 18.2278 5.49976 18.0225 5.5 17.815C5.49927 17.4422 5.6361 17.0823 5.88429 16.8041C6.13247 16.5259 6.47455 16.3491 6.845 16.3075V16.308Z"
      fill="none"
      className={className}
    />
    <path
      d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10C8 8.93913 8.42143 7.92172 9.17157 7.17157C9.92172 6.42143 10.9391 6 12 6C13.0609 6 14.0783 6.42143 14.8284 7.17157C15.5786 7.92172 16 8.93913 16 10Z"
      fill="none"
      className={className}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 13C12.7956 13 13.5587 12.6839 14.1213 12.1213C14.6839 11.5587 15 10.7956 15 10C15 9.20435 14.6839 8.44129 14.1213 7.87868C13.5587 7.31607 12.7956 7 12 7C11.2044 7 10.4413 7.31607 9.87868 7.87868C9.31607 8.44129 9 9.20435 9 10C9 10.7956 9.31607 11.5587 9.87868 12.1213C10.4413 12.6839 11.2044 13 12 13ZM12 14C13.0609 14 14.0783 13.5786 14.8284 12.8284C15.5786 12.0783 16 11.0609 16 10C16 8.93913 15.5786 7.92172 14.8284 7.17157C14.0783 6.42143 13.0609 6 12 6C10.9391 6 9.92172 6.42143 9.17157 7.17157C8.42143 7.92172 8 8.93913 8 10C8 11.0609 8.42143 12.0783 9.17157 12.8284C9.92172 13.5786 10.9391 14 12 14Z"
      fill="none"
      className={className}
    />
  </svg>
);

export { ProfileSVG };
